import React from "react";
import { Select as ReactSelect } from "@paylixecommerce/shared/components";


const Select = ({
	disabled,
	label,
	menuIsOpen = undefined,
	isSearchable = false,
	options,
	wrapperClassName,
	name,
	isMulti,
	onChange,
	note,
	placeholder,
	onlyCustomChange,
	handleChange,
	values,
	touched,
	errors,
	...rest
}) => {

	let isError = errors[name] && touched[name];

	return <div className={`${wrapperClassName} mb-4`}>
		{label && <label className="paylixecommerce-label" htmlFor={name}>{label}</label>}
		{note && <span className="paylixecommerce-note">{note}</span>}
		{note && <br/>}
		<ReactSelect
			options={options}
			name={name}
			isMulti={isMulti}
			placeholder={placeholder}
			menuIsOpen={menuIsOpen}
			isDisabled={disabled}
			isSearchable={isSearchable}
			value={options.find(({ value }) => values[name] === value)}
			className={isError ? "is-invalid-select" : ""}
			{...rest}
			onChange={options => {
				if(onlyCustomChange) {
					if(onChange) {
						onChange(options);
					}
				} else {
					handleChange(`${name}`)(options.value)
					if(onChange) {
						onChange(options);
					}
				}
			}}
		/>
		{isError && <div className="invalid-feedback">{errors[name]}</div>}
	</div>
}

export default Select;
